module.exports = __webpack_public_path__ + "img/NO989997254.b1f8083f.png";